import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import AlertIcon from '@tradera/blueprint/theme/icons2/alert.svg?jsx';

const _UnpaidItem = ({ unpaidItemUrl }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <div className="alert alert-info">
            <div className="d-flex">
                <AlertIcon className={`icon icon-md mr-2`} />
                <h5>{t('leaveFeedback_upiHeading')}</h5>
            </div>

            <p>
                <a
                    className=""
                    target="_blank"
                    rel="noreferrer"
                    href={toLocalizedUrl(unpaidItemUrl)}>
                    {t('leaveFeedback_upiLink')}
                </a>
            </p>
        </div>
    );
};
export const UnpaidItem = React.memo(_UnpaidItem);
